import { useContext, useEffect, useReducer, useState } from "react";
import UserTable from "./UserTable";
import useAuthFetch from "../../hooks/useAuthFetch";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import toast from "react-hot-toast";
import { formatDate } from "../../utils/common";

export default function AllUser() {
  const customFetch = useAuthFetch();
  const [query, setQuery] = useState({});
  const [isReady, setIsReady] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [object, setObject] = useState([
    {
      label: "ntId",
      searchFilter: "ntId",
      value: null,
    },
    {
      label: "IDM Task Id",
      searchFilter: "meTicketNo",
      value: null,
    },
    {
      label: "Role",
      searchFilter: "role",
      value: null,
    },
    {
      searchFilter: "start",
      value: null,
    },
    {
      searchFilter: "end",
      value: null,
    },
  ]);


  // useEffect(() => {
  //   // Simulate query fetching and setting router readiness
  //   // const simulatedQuery = { param1: "value1", param2: "value2" }; // Replace with actual logic
  //   // setQuery(simulatedQuery);
  //   setIsReady(true);
  // }, []);
  useEffect(() => {
    const simulatedQuery = {};
    object.forEach((item) => {
      if (item.value !== null) {
        if (item.searchFilter === "start" || item.searchFilter === "end") {
          simulatedQuery[item.searchFilter] = new Date(item.value).toISOString();
        } else {
          simulatedQuery[item.searchFilter] = item.value;
        }
      }
    });

    // Parse existing query params from the URL
    const searchParams = new URLSearchParams(location.search);
    const existingQuery = Object.fromEntries(searchParams.entries());

    // Remove keys from `existingQuery` that have a `null` value in `object`
    Object.keys(existingQuery).forEach((key) => {
      const correspondingObjectItem = object.find((item) => item.searchFilter === key);
      if (correspondingObjectItem && correspondingObjectItem.value === null) {
        delete existingQuery[key];
      }
    });

    // Combine `existingQuery` with `simulatedQuery` and add `page=1`
    const newQuery = {
      ...existingQuery,
      ...simulatedQuery,
      page: 1, // Reset page to 1
    };

    // Filter out null or undefined values
    const filteredQuery = Object.fromEntries(
      Object.entries(newQuery).filter(([_, value]) => value !== null && value !== undefined)
    );

    // Update the state and URL
    setQuery(filteredQuery);

    const newSearch = new URLSearchParams(filteredQuery).toString();
    if (location.search !== `?${newSearch}`) {
      navigate(`${location.pathname}?${newSearch}`, { replace: true });
    }
    setIsReady(true);
    // Simulate query fetching and setting router readiness
    // const simulatedQuery = { param1: "value1", param2: "value2" }; // Replace with actual logic
    // setQuery(simulatedQuery);
    setIsReady(true);
  }, [object]);

  function reducer(state, action) {
    switch (action.type) {
      case "LOADING":
        return { ...state, isLoading: true };

      case "UPDATE":
        return { ...state, response: action.payload, isLoading: false };

      case "ERROR":
        return { ...state, response: null, isLoading: false };

      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    response: null,
    isLoading: false,
  });

  const handleFetch = async () => {
    if (!isReady || state.isLoading) return;

    dispatch({ type: "LOADING" });

    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/user/fetchAll`
    );
    // Include query parameters with defaults for pagination
    url.search = new URLSearchParams({
      ...query,
      page: query.page || 1, // Always default to page 1 if not specified
      perPage: query.perPage || 20, // Default to 20 rows per page
    }).toString();

    try {
      const method = "GET"
      const { response, status } = await customFetch(
        url,
        method,
      );

      if (status === 200) {
        dispatch({ type: "UPDATE", payload: response });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "ERROR" });
    }
  };

  useEffect(() => {
    if (user && user.role === "SUPPORT" && location?.state?.showToast) {
      toast.success(
        `Last Successful Login: ${user?.lastSuccessfulLogin
          ? formatDate(user?.lastSuccessfulLogin)
          : "N/A"
        } \n Last Failed Login: ${user?.lastFailedLogin ? formatDate(user?.lastFailedLogin) : "N/A"
        }`,
        {
          position: "bottom-right",
          style: {
            maxWidth: "500px",
            whiteSpace: "nowrap",
          },
        }
      );
    }
  }, []);

  const handleFetchWithPage = async (page) => {
    const updatedQuery = { ...query, page }; // Merge current query with the new page
    const searchParams = new URLSearchParams(updatedQuery).toString();

    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/user/fetchAll`
    );
    url.search = searchParams;

    dispatch({ type: "LOADING" });

    try {
      const method = "GET"
      const { response, status } = await customFetch(
        url,
        method,
      );
      if (status === 200) {
        dispatch({ type: "UPDATE", payload: response });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (err) {
      console.error("Fetch error:", err);
      dispatch({ type: "ERROR" });
    }
  };


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const updatedQuery = Object.fromEntries(searchParams.entries());

    setQuery(updatedQuery);

    // Fetch the new data based on updated query
    if (isReady) handleFetch();
  }, [location.search, isReady]);


  return (
    <div className="overflow-y-hidden">
      {isReady && <UserTable reqState={state} object={object} setObject={setObject} handleFetch={handleFetch} handleFetchWithPage={handleFetchWithPage} />}
    </div>
  );
}
